"use strict";

(function(z, Backbone){

    var ProjectsRepresentativesClientContractsCollection = Backbone.Collection.extend({
        // nothing
    });

    z.ProjectsRepresentativesClientContractsCollection = ProjectsRepresentativesClientContractsCollection;

})(window.z = window.z || {}, Backbone);